import { EnumerationBuilder } from 'utility-js-enumeration';
export const RenderTypeEnum = EnumerationBuilder.useDefinitionAsEnum('RenderTypeEnum', {
  USER_PASS_LOGIN: 'USER_PASS_LOGIN',
  BUTTON_ONLY_LOGIN: 'BUTTON_ONLY_LOGIN'
});



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/types/render_type_enum.ts